/**
 * Initially used to safely parse the JSON from CQE qualification raw data
 * @param json
 */
export function safeParseJSON(json: string){
  if(json === ''){
    return ''
  }

  try {
    return JSON.parse(json)
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch(e){
    return json
  }
}
